<template>
    <v-app class="primary" id="login">
        <v-content>
            <v-container fill-height fluid>
                <v-layout align-center justify-center>
                    <v-flex lg4 md4 sm8 xs12>
                        <v-card class="elevation-1 pa-3">
                            <v-form @submit.prevent="register" v-if="token_uid.length === 0" ref="form" >
                                <v-card-text>
                                    <div class="layout column align-center">
                                        <router-link to="/">
                                            <img alt="چاپچی" height="124" src="/static_reseller/m.png" width="288">
                                        </router-link>
                                        <h1 class="flex my-4 primary--text">ثبت نام</h1>
                                    </div>
                                    <v-radio-group v-model="model.person_type">
                                        <v-layout>
                                            <v-flex>
                                                <v-radio
                                                        key="Individual"
                                                        label="حقیقی"
                                                        value="Individual"
                                                        @click="form.sex = 'Male'"
                                                ></v-radio>
                                            </v-flex>
                                            <v-flex>
                                                <v-radio
                                                        key="Legal"
                                                        label="حقوقی"
                                                        value="Legal"
                                                ></v-radio>
                                            </v-flex>
                                        </v-layout>
                                    </v-radio-group>
                                    <v-layout>
                                        <v-flex v-if="model.person_type !== 'Legal'">
                                            <v-text-field
                                                    label="نام"
                                                    name="name"
                                                    type="text"
                                                    v-model="model.name"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    :label="model.person_type === 'Legal'?'نام شرکت':'نام خانوادگی '"
                                                    name="family"
                                                    type="text"
                                                    required
                                                    :rules="[rules.required]"
                                                    v-model="model.family"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-text-field
                                            v-if="model.person_type === 'Legal'"
                                            label="شناسه‌ی ملی"
                                            name="national_id"
                                            type="text"
                                            data-ltr
                                            v-model="model.national_id"
                                            :rules="[rules.required]"
                                            maxlength="11"
                                            required
                                    ></v-text-field>
                                    <v-layout v-if="model.person_type == 'Legal'">
                                        <v-flex sm8>
                                            <v-text-field
                                                    label="نام رابط شرکت"
                                                    name="connector_name"
                                                    type="text"
                                                    v-model="model.connector_name"
                                                    maxlength="72"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex sm4>
                                            <v-text-field
                                                    label="سمت"
                                                    name="connector_post"
                                                    type="text"
                                                    v-model="model.connector_post"
                                                    maxlength="72"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-text-field
                                            label="موبایل"
                                            name="mobile"
                                            type="text"
                                            data-ltr
                                            v-model="model.mobile"
                                            maxlength="11"
                                            @change="first_zero"
                                            :rules="[rules.required]"
                                            required
                                    ></v-text-field>
                                    <v-text-field
                                            label="ایمیل"
                                            name="email"
                                            data-ltr
                                            type="text"
                                            v-model="model.email"
                                            maxlength="72"
                                            required
                                            :rules="[() => evalidate(model.email) || 'ایمیل نامعتبر است!']"
                                    ></v-text-field>
                                    <v-text-field
                                            id="password"
                                            label="رمزعبور"
                                            name="password"
                                            type="password"
                                            data-ltr
                                            new-password
                                            v-model="model.password"
                                            :rules="[() => model.password.length > 8 || 'طول رمز عبور حداقل 8 کاراکتر']"
                                            required
                                    ></v-text-field>

                                    <v-radio-group v-model="model.sex" v-if="model.person_type !== 'Legal'">
                                       <v-layout>
                                           <v-flex> <v-radio label="مرد" value="Male"></v-radio></v-flex>
                                           <v-flex><v-radio label="زن" value="Female"></v-radio></v-flex>
                                       </v-layout>
                                    </v-radio-group>

                <!--  <vue-recaptcha sitekey="6LextJMUAAAAAPSw1gQpXmiUIlnqb5gxsuMy__nZ">
                                              <button>من ربات نیستم</button>
                                          </vue-recaptcha>-->
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn :loading="loading" block color="primary" type="submit">
                                        تایید
                                    </v-btn>
                                </v-card-actions>
                            </v-form>
                            <v-form v-else @ v-on:submit.prevent="twoFactory" ref="tform">
                                <v-card-text>
                                    <div class="layout column align-center">
                                        <router-link to="/">
                                            <img alt="چاپچی" height="120" src="/static_reseller/m.png" width="120">
                                        </router-link>
                                        <h1 class="flex my-4 primary--text">تایید تلفن همراه</h1>
                                    </div>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="کد تایید"
                                                    name="name"
                                                    type="text"
                                                    maxlength="7"
                                                    data-number
                                                    required
                                                    :rules="[rules.required]"
                                                    v-model="token_user"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-chip :style="resend?'cursor:pointer;':''" @click="resendCode" :color="resend?'green':'gray'" :text-color="resend?'white':'blue'">ارسال مجدد {{timer_counter}}</v-chip>
                                    </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn :loading="loading" block color="primary" type="submit">
                                        تایید
                                    </v-btn>
                                </v-card-actions>
                            </v-form>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
/* import VueRecaptcha from 'vue-recaptcha'; */
import * as EmailValidator from 'email-validator';
export default {
  /*  components: {
          VueRecaptcha
        }, */
  data: () => ({
    loading: false,
    model: {
      name: '',
      family: '',
      mobile: '',
      email: '',
      sex: 'Male',
      national_id: '',
      connector_name: '',
      connector_post: '',
      person_type: 'Individual',
      password: ''
    },
    token_uid: '',
    token_user: '',
    interval: null,
    timer: 0,
    resend: false,
    timer_counter: '(02:00)',
    rules: {
      required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
    }
  }),
  mounted: () => {

  },
  methods: {
    register () {
      if (!this.$refs.form.validate()) {
        window.getApp.$emit('INVALID_FORM');
        return;
      }
      this.loading = true;
      this.model.sex = this.model.person_type === 'Legal' ? 'Company' : this.model.sex;
      this.model.name = this.model.person_type === 'Legal' ? 'شرکت' : this.model.name;
      this.model.national_id = this.toPersianDigit(this.model.national_id, true);
      this.axios.post('/register', this.model)
        .then(response => {
          this.token_uid = response.data.content;
          this.timer = 120;
          this.interval = setInterval(this.countDown, 1000);
          this.loading = false;
        }).catch(error => {
          this.loading = false;
          window.getApp.$emit('SHOW_ERROR', error.response.data.message);
        });
    },
    resendCode () {
      if (!this.resend) {
        return;
      }
      this.resend = false;
      this.axios.post('/register/resend_sms', { uid: this.token_uid, captcha: '' }).then(response => {
        window.getApp.$emit('SHOW_SUCCESS', 'با موفقیت ارسال شد.');
        this.resend = false;
        this.timer = 120;
        this.token_uid = response.data.content;
        this.interval = setInterval(this.countDown, 1000);
      }).catch(error => {
        this.resend = true;
        window.getApp.$emit('SHOW_ERROR', error.response.data.message);
      });
    },
    countDown () {
      let n = this.timer;
      if (n > 0) {
        n = n - 1;
        this.timer = n;
        let minute = Math.floor(n / 60);
        let second = n % 60;
        second = second < 10 ? '0' + second : second;
        this.timer_counter = '(' + minute + ':' + second + ')';
      } else {
        clearInterval(this.interval);
        this.timer_counter = '';
        this.resend = true;
      }
    },
    twoFactory () {
      if (!this.$refs.tform.validate()) {
        window.getApp.$emit('INVALID_FORM');
        return;
      }
      this.loading = true;
      this.$auth.register({
        data: { uid: this.token_uid, token: this.token_user, captcha: '' },
        rememberMe: true
      }).then((response) => {
        this.loading = false;
        localStorage.setItem('default_auth_token', response.data.token);
      }, (error) => {
        this.loading = false;
        window.getApp.$emit('SHOW_ERROR', error.response.data.message);
      });
    },
    first_zero () {
      if (this.model.mobile.length === 0) {
        return;
      }
      this.model.mobile = this.toPersianDigit(this.model.mobile, true);
      this.model.mobile = this.model.mobile.replace('+98', '');
      if (this.model.mobile.substr(0, 2) !== '09') {
        if (this.model.mobile.substr(0, 1) !== '0') {
          this.model.mobile = '09' + this.model.mobile;
        } else {
          this.model.mobile = '0' + this.model.mobile;
        }
      }
      if (this.model.mobile.length > 11) {
        this.model.mobile = this.model.mobile.substr(0, 11);
      }
    },
    evalidate (email) {
      return EmailValidator.validate(email);
    }
  }
};
</script>
<style scoped lang="css">
    #login {
        height: 50%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
    }
    .input[data-ltr] {
        direction: ltr !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue